import styled from "@emotion/styled";

export const WrapperTimer = styled.div`
display: flex;
justify-content: center;
align-items: center;
gap: 10px;
margin-bottom: 20px;
`;

export const WrapperTimerItem = styled('div')(({ theme }) => `
display: flex;
flex-direction: column;
gap: 4px;
width: 80px;
padding: 4px 6px 4px 6px;
border-radius: 4px;
border-color: transparent;
background-color: ${theme.palette.background.primary};
box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
`);

export const TimeItem = styled.span`
font-size: 20px;
line-height: 1.1;
`;

export const TimeType = styled.span`
font-size: 12px;
text-transform: uppercase;
line-height: 1.1;
`;